import React, { useEffect } from 'react';
import Form from 'react-bootstrap/Form';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { default as TooltipButton } from 'react-bootstrap/Button';
import { useFormContext } from 'react-hook-form';
import useValidation from 'conversie-flow-bundle/assets/js/components/flow/hooks/useValidation';

/* Common */
import { PriceFormat, Icon } from '~/components/common';

/* Icons */
import InfoIcon from '~/../symbols/info-circle.svg';

export default function ConversionFieldChoice(props) {
    const { customControlClassName = '', field, inputType, path, id, updateChoice } = props;
    const { choices, required, disabled, label, value } = field;

    const form = useFormContext();
    const {
        setValue = () => { },
        trigger = () => { },
    } = form || {};

    const { error } = useValidation({ path, ...field, ...form });

    useEffect(() => {
        setValue(path, value);
    }, [value]);

    useEffect(() => {
        sessionStorage.setItem('monthly', props.pricePerMonth);
    }, [props.pricePerMonth]);

    return (
        <div className="row gutters-0 mb-5">
            {label && (
                <div className="col-12">
                    <p className="flow__label mb-2 mb-xl-3">{label}</p>
                </div>
            )}
            <div className="col-12">
                <div className="row gutters-0 custom-choices">
                    {choices?.map((choice, choiceIndex) => {
                        return (
                            <div className={choice?.price ? 'col-12' : 'col'} key={choice.key}>
                                <Form.Check
                                    className={`custom-${inputType} ${customControlClassName} ${error ? 'is-error' : ''}`}
                                    type={inputType}
                                    id={`${id}.choices.${choiceIndex}-${choice.key}`}
                                >
                                        <Form.Check.Input
                                            type={inputType}
                                            className="custom-control-input"
                                            name={id}
                                            value={choice.key}
                                            {...{
                                                required,
                                                disabled,
                                            }}
                                            checked={value?.includes(choice.key)}
                                            onChange={(e) => {
                                                updateChoice(choice, e.target.checked, () => {
                                                    if (choice.key === 'monthly') {
                                                        sessionStorage.removeItem('price');
                                                        sessionStorage.setItem('monthly', props.pricePerMonth);
                                                    } else if (choice.key === 'single') {
                                                        sessionStorage.removeItem('monthly');
                                                        sessionStorage.setItem('price', props.vehiclePrice);
                                                    }
                                                    trigger(path);
                                                });
                                            }}
                                        />
                                        <Form.Check.Label className={`custom-control-label ${field?.name === 'paymenttype' ? 'custom-control-label--paymenttype' : ''}`}>
                                            <div className={`custom-control-label__title ${choice?.price !== null && choice?.price !== undefined ? 'justify-content-between' : ''}`}>
                                                {(choice.tooltip && choice.tooltip !== '') && (
                                                    <OverlayTrigger
                                                        placement="bottom"
                                                        overlay={
                                                            <Tooltip id={`tooltip-${id}.choices.${choiceIndex}-${choice.key}`}>
                                                                {choice.tooltip}
                                                            </Tooltip>
                                                        }
                                                    >
                                                        <TooltipButton
                                                            variant="none"
                                                            className="mr-1 p-0 btn--tooltip"
                                                        >
                                                            <Icon
                                                                theme="base"
                                                                size={16}
                                                                url={InfoIcon?.url}
                                                                className={`icon--tooltip`}
                                                            />
                                                        </TooltipButton>
                                                    </OverlayTrigger>
                                                )}
                                                <span dangerouslySetInnerHTML={{ __html: choice.label }} />
                                                {field?.name === 'paymenttype' && (
                                                    <p className="label__price font-weight-bold">
                                                        {choice.key === 'monthly' ? (
                                                            <PriceFormat value={props.pricePerMonth} prefix=' ' suffix=',-' />
                                                        ) : (
                                                            <PriceFormat value={props.vehiclePrice} prefix=' ' suffix=',-' />
                                                        )}
                                                    </p>
                                                )}
                                                {choice?.price !== undefined && choice?.price !== null && (
                                                    <p className="label__price font-weight-bold">
                                                        {choice.price > 0 ? (
                                                            <PriceFormat value={choice.price} prefix='+ ' suffix=',-' />
                                                        ) : (
                                                            <span className="text-success">Gratis</span>
                                                        )}
                                                    </p>
                                                )}
                                            </div>
                                            {choice?.['pay-off'] && (
                                                <span className="custom-control-label__pay-off">{choice?.['pay-off']}</span>
                                            )}
                                        </Form.Check.Label>
                                </Form.Check>
                            </div>
                        );
                    })}
                </div>
            </div>
            {error && (
                <Form.Control.Feedback type="invalid">
                    {error}
                </Form.Control.Feedback>
            )}
        </div>
    );
}
